import SwitchComponent from "./SwitchComponent";
import { useCallback } from "react";
import { useAppDispatch } from "@portal/redux/store";
import { setLanguage } from "@portal/redux/reducers/languageReducer";
import { NORNE_CENTERID } from "@portal/assets/banks";

interface Props {
  isDefaultLanguage: boolean;
  centerId: string;
}

/**
 * Component to toggle between two languages.
 * @returns a switch toggle button.
 */
export const LanguageSelector = ({ isDefaultLanguage, centerId }: Props) => {
  const dispatch = useAppDispatch();

  const OnLanguageClick = useCallback(() => {
    dispatch(setLanguage(!isDefaultLanguage));
  }, [dispatch, isDefaultLanguage]);

  return <SwitchComponent checked={!isDefaultLanguage} onChange={OnLanguageClick} invert={getInvertedBanks(centerId)} />;
};

const getInvertedBanks = (centerId: string) => {
  return [NORNE_CENTERID, "2220", "9820", "4589", "4730", "4605"].includes(centerId);
};
